<template>
  <div class="footer_wrapper">
    <div class="copyright">
      <!-- 320以下だどここが崩れる -->
      <small>Copyright (C) 2009-{{ now }} <a href="https://www.tonio.or.jp/" rel="home" target="_blank">Toyama New Industry Organization</a> <br class="sp_br" > All Rights Reserved.</small>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      now: ''
    }
  },
  mounted () {
    this.now = new Date().getFullYear()
  }
}
</script>

<style lang="scss">
  .footer_wrapper {
    .copyright {
      width: 100%;
      height: 26px;
      margin-top: 40px;
      text-align: center;
      color: #fff;
      background-color: #000;
      font-size: 11px;
      line-height: 26px;

      .sp_br {
        display: none;
      }

      a, a:link, a:hover, a:visited, a:active {
        color: #fff;
      } 
      a:hover {
        text-decoration: none;
      }
    }

    // 以下、SP（スマホ以下）
    @media all and (max-width: 767px) {
      .copyright {
        font-size: 10px;
        height: 51px;
        line-height: 1.6;
        position: relative;
        
        small {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          margin: auto;
          padding: 10px;
        }

        .sp_br {
          display: inline;
        }
      }
    }
  }
</style>